/* Componente Noticias - Solo Lógica */
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../context/LanguageContext';
import { noticiasData } from '../context/News_translate';
import NewsUI from '../ui/News_UI';

const Noticias = () => {
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);
  
  const [paginaActual, setPaginaActual] = useState(1);
  const noticiasPorPagina = 4;

  // Ordenar noticias por fecha (más recientes primero)
  const noticiasOrdenadas = Object.entries(noticiasData)
    .sort((a, b) => new Date(b[1].date.split('/').reverse().join('-')) - new Date(a[1].date.split('/').reverse().join('-')));
  
  // Calcular paginación
  const totalNoticias = noticiasOrdenadas.length;
  const totalPaginas = Math.ceil(totalNoticias / noticiasPorPagina);
  const indexInicio = (paginaActual - 1) * noticiasPorPagina;
  const indexFin = indexInicio + noticiasPorPagina;
  const noticiasAPresentar = noticiasOrdenadas.slice(indexInicio, indexFin);

  // Handlers
  const handlePaginaAnterior = () => {
    setPaginaActual((pagina) => Math.max(pagina - 1, 1));
  };

  const handlePaginaSiguiente = () => {
    setPaginaActual((pagina) => Math.min(pagina + 1, totalPaginas));
  };

  const handleLeerMas = (id, noticia) => {
    navigate(`/noticia/${id}`, { state: { noticia } });
  };

  return (
    <NewsUI
      language={language}
      noticias={noticiasAPresentar}
      paginaActual={paginaActual}
      totalPaginas={totalPaginas}
      onPaginaAnterior={handlePaginaAnterior}
      onPaginaSiguiente={handlePaginaSiguiente}
      onLeerMas={handleLeerMas}
    />
  );
};

export default Noticias;